<template>
  <s-sidebar margin-top="var(--topbar-height)" :route="route">
    <template #items>
      <s-sidebar-item v-if="user?.tipo_id !== 4"
        route="/"
        label="Home"
        icon="mdiHome"
      />

      <s-sidebar-item v-if="user?.tipo_id !== 4"
        route="/aplicativos"
        label="Aplicativos"
        icon="mdiApps"
      />

      <template v-if="[1].includes(Number(user?.tipo_id))">
        <s-sidebar-item-group label="Usuários" icon="mdiAccountMultipleOutline">
          <s-sidebar-sub-item
            route="/usuarios"
            label="Usuários"
          />
          <s-sidebar-sub-item
            route="/usuarios/tipos"
            label="Tipos"
          />
        </s-sidebar-item-group>
      </template>
      
      <template v-else>
        <s-sidebar-item v-if="user?.tipo_id !== 4"
          route="/usuarios"
          label="Usuários"
          icon="mdiAccountMultipleOutline"
        />
      </template>

      <s-sidebar-item v-if="user?.tipo_id !== 4"
        route="/escolas"
        label="Escolas"
        icon="mdiSchool"
      />

      <s-sidebar-item v-if="user?.tipo_id !== 4"
        route="/turmas"
        label="Turmas"
        icon="mdiAccountGroup"
      />

      <s-sidebar-item v-if="user?.tipo_id !== 4"
        route="/equipamentos"
        label="Equipamentos"
        icon="mdiTabletCellphone"
      />

      <s-sidebar-item v-if="user?.tipo_id !== 4"
        route="/relatorios"
        label="Relatórios"
        icon="mdiChartBar"
      />

      <s-sidebar-item v-if="user?.tipo_id !== 4"
        route="/planos"
        label="Planos de Aula"
        icon="mdiBookOpenVariant"
      />

      <s-sidebar-item
        route="/agenda"
        label="Agenda"
        icon="mdiCalendarMonthOutline"
      />

      <s-sidebar-item v-if="user?.tipo_id !== 4"
        route="/cursos"
        label="Cursos"
        icon="mdiPlayCircleOutline"
      />

      <s-sidebar-item v-if="[1].includes(Number(user?.tipo_id))"
        route="/organizacao"
        label="Organização"
        icon="mdiDomain"
      />

      <s-sidebar-item v-if="[1, 2, 3].includes(Number(user?.tipo_id))"
        route="/guias"
        label="Guias de Uso"
        icon="mdiBookOpenPageVariantOutline"
      />
    </template>

    <template #actions>
      <div class="version-container" v-tooltip="`Versão: ${version}`">
        {{ version }}
      </div>
    </template>
  </s-sidebar>
</template>

<script setup lang="ts">
import { SSidebar, SSidebarItem, SSidebarItemGroup, SSidebarSubItem } from '@sieg-ad/componentes-vue';
import { useAuthStore } from '~/stores/auth';

const authStore = useAuthStore();
const { user } = storeToRefs(authStore);
const route = useRoute();
const version = ref<string>(useRuntimeConfig().public.APP_VERSION);
</script>

<style scoped>
.version-container {
  padding: 0.5rem;
  font-size: 0.8rem;
  color: var(--text-tertiary);
  width: 100%;
  text-align: center;
}
</style>
